import React from 'react'

const Loader = React.memo(({ text = 'Loading...', show = true, fullscreen = true ,coverBg = false}) => {
    if (!show) return null

    const overlayClass = fullscreen
        ? `fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center ${coverBg ? `z-[200]` : "z-50"}`
        : "absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center z-40"

    return (
        <div className={overlayClass}>
            <div className="w-12 h-12 border-4 border-gray-600 border-t-[#fff] rounded-full animate-spin mb-4"></div>
        </div>
    )
})

export default Loader
